<template>
<multiselect 
    v-model="cur_value" 
    select-label=""
    :options="suggestions" 
    :custom-label="label"
    track-by="id" 
    :loading="isLoading" 
    :multiple="multiple"
    :hideSelected="true"
    :placeholder="placeholder"
    :allow-empty="true"
    @search-change="searchUser" 
    @input="update"
    @select="select">
    <template slot="option" slot-scope="props">
        <div class="item">
            <dp :who="props.option" />
            <h3>{{props.option.firstname}} {{props.option.lastname}}</h3>
        </div>
    </template>
    <span slot="noResult">
        {{ noResultText }}
    </span>
</multiselect>
</template>

<script>
import Multiselect from 'vue-multiselect'
import dp from 'components/dp.vue'

export default {
    components: { 'Multiselect': Multiselect, 'dp': dp },
    props: [ 'value', 'multiple', 'placeholder', 'type' ],
    data () {
        return {
            cur_value: this.value,
            suggestions: [],
            isLoading: false
        }
    },
    computed: {
        noResultText () {
            if (this.type == 'friends') {
                return 'Keine Freunde gefunden'
            } else {
                return 'Keine Benutzer gefunden'
            }
        }
    },
    created () {
        this.searchUser('')
    },
    methods: {
        searchUser (query) {
            this.isLoading = true

            const that = this
            this.$api.get(`users/${this.type}/search`, {
                query: query
            })
            .then(response => {
                that.suggestions = response.data
                that.isLoading = false
            })
        },
        label ({ firstname, lastname}) {
            return `${firstname} ${lastname}`
        },
        update (value, id) {
            this.$emit('input', this.cur_value)
        },
        select (selectedOption, id) {
            this.$emit('select', selectedOption, id)
        }
    }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>



// WEBPACK FOOTER //
// user-select.vue?c35be6e0